import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mk',
    fullName: 'Macedonian',
    nativeName: 'Македонски',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Нешто неверојатно доаѓа",
    landing_subtitle: "ArgVoid е студио за развој на апликации и игри. Останете во тек, нови работи доаѓаат наскоро!",
    select_language: "Изберете Јазик",
    search_placeholder: "Пребарувајте јазици...",
    terms_title: "Услови за користење",
    policy_title: "Политика за приватност",
    cookies_title: "Политика за колачиња",
    terms_content: `
        <strong>1. Прифаќање на условите</strong><br>
        Со пристап до ArgVoid, овие Услови за користење се прифаќаат. Доколку овие услови не се согласни, услугата не треба да се користи.<br><br>

        <strong>2. Употреба на платформа</strong><br>
        ArgVoid и неговите апликации се обезбедени „како што е“ за информативни и креативни цели. Услугата мора да се користи само за законски цели.<br><br>

        <strong>3. Забрането однесување</strong><br>
        Строго е забрането искористување на пропусти на страницата, спамирање или обид за неовластен пристап до инфраструктурата.<br><br>

        <strong>4. Одрекување</strong><br>
        Платформата и услугите може да се изменат во секое време без претходна најава. Не се обезбедува гаранција во врска со времето на работа или достапноста на услугата.
    `,
    policy_content: `
        <strong>1. Колекција на информации</strong><br>
        Платформата во моментов не бара автентикација на корисникот или создавање сметка. Нема информации за лична идентификација (како што се имиња или адреси на е-пошта) активно се собираат од посетителите.<br><br>

        <strong>2. Користење Data</strong><br>
        Може да се собере основна, анонимизирана аналитика за да се разбере сообраќајот на страницата и да се подобрат апликациите. Овие податоци не се поврзани со индивидуални кориснички идентитети.<br><br>

        <strong>3. Услуги од трета страна</strong><br>
        Трети даватели на услуги може да се користат за хостинг и аналитички услуги. Практиките за приватност на овие соодветни добавувачи ги регулираат анонимните податоци обработени на нивната инфраструктура.<br><br>

        <strong>4. Безбедност на податоци</strong><br>
        Се спроведуваат разумни безбедносни мерки за заштита на платформата. Меѓутоа, ниту еден начин на пренос преку Интернет не е целосно безбеден.<br><br>
    `,
    cookies_content: `
        <strong>1. Што се колачиња и локално складирање?</strong><br>
        Колачињата и локалното складирање на прелистувачот се мали датотеки со податоци складирани на уредот за да се запомнат поставките за конфигурација низ посетите.<br><br>

        <strong>2. Цел на употреба</strong><br>
        Прелистувачот LocalStorage се користи строго за зачувување на поставките за конфигурација, како што се:<br>
        - Јазични преференции<br>
        - Конфигурација на корисничкиот интерфејс (на пр., поставки за распоред или тема) <br>
        - Кеш за привремена апликација<br><br>

        <strong>3. Нема следење</strong><br>
        Колачињата и локалното складирање не се користат за рекламирање или за следење од трета страна. Сите складирани податоци се строго за основната функционалност на платформата.<br><br>

        <strong>4. Контрола</strong><br>
        Податоците од прелистувачот може да се исчистат во секое време преку поставките на прелистувачот, што ќе ги ресетира сите локални конфигурации.
    `,
    cookie_consent_text: "Ние користиме основни колачиња за да обезбедиме правилно функционирање на веб-локацијата, како што е одржувањето на вашата сесија активна, зачувувањето на вашите претпочитани јазици и други сопствени конфигурации.",
    read_policy: "Прочитајте ја политиката за колачиња",
    support_title: "Контактирајте со поддршката",
    support_subject_label: "Предмет",
    support_message_label: "Порака",
    support_submit_button: "Испрати порака",
    support_hint: "Забелешка: Ова ќе ја отвори вашата стандардна апликација за е-пошта за да ја испратите пораката.",
    support_success_msg: "Се отвора вашата апликација за е-пошта...",
    support_error_msg: "Не успеа да се испрати порака. Обидете се повторно подоцна.",
    explorer_title: "Истражувач",
    history_title: "Историја",
    animation_title: "Анимација",
    config_title: "Конфигурација",
    tool_mouse: "Изберете (Ctrl+M)",
    tool_brush: "Четка (Ctrl+B)",
    tool_brush_mode: "Префрли режим (цврст/чист)",
    tool_eraser: "Бришач (Ctrl+E)",
    tool_brush_size: "Прилагодете ја големината на четката",
    tool_bucket: "Пополнете (Ctrl+F)",
    tool_eyedropper: "Капкалка за очи",
    tool_grid: "Решетка (Ctrl+Shift+B)",
    tool_rotate: "Ротирај (Ctrl+Shift+R)",
    tool_flip_h: "Преврти H (Ctrl+Shift+H)",
    tool_flip_v: "Превртете V (Ctrl+Shift+V)",
    tool_transpose: "Транспонирање (Ctrl+Shift+T)",
    label_width: "Ширина",
    label_height: "Висина",
    label_frames: "Број на рамки",
    label_animation: "Стил на анимација",
    label_background_color: "Боја на позадината",
    label_interval: "Интервал",
    tool_anim_config: "Конфигурација на анимација",
    label_new_width: "Нова ширина",
    label_new_height: "Нова висина",
    label_apply: "Пријавете се",
    label_colors: "Бои",
    label_size: "Големина",
    label_tolerance: "Толеранција",
    val_horizontal: "Хоризонтална",
    val_vertical: "Вертикална",
    val_sequence: "Секвенца",
    val_bounce: "Отскокнување",
    val_random: "Случајно",
    val_solid: "Цврсти",
    val_clear: "Јасно",
    action_add_sheet: "Нов лист",
    action_import: "Увоз",
    action_export: "Извоз",
    action_sort_projects: "Подреди",
    sort_date_old: "Прво најстариот",
    sort_date_new: "Најновото прво",
    sort_name_az: "Име (A-Z)",
    sort_name_za: "Име (Z-A)",
    action_new_sprite: "Нов Спрајт",
    action_new_project: "Нов проект",
    modal_save_all_title: "Зачувај ги сите промени",
    modal_save_all_desc: "Изберете ги средствата за зачувување:",
    modal_save_selected: "Зачувај го избраното",
    action_saved: "Зачувано",
    modal_create_sprite_title: "Креирај нов Sprite",
    modal_create_project_title: "Креирај нов проект",
    modal_add_sheet_title: "Додадете нов лист",
    modal_rename_sheet_title: "Преименувајте го листот",
    modal_rename_sprite_title: "Преименувајте го Sprite",
    modal_delete_sprite_title: "Избришете го Sprite",
    modal_delete_project_title: "Избриши го проектот",
    modal_delete_sheet_title: "Избриши лист",
    placeholder_sprite_name: "Име",
    placeholder_project_name: "Име",
    placeholder_sheet_name: "Име",
    placeholder_new_name: "Ново име",
    action_create: "Креирај",
    action_add: "Додадете",
    action_rename: "Преименувај",
    action_duplicate: "Дупликат",
    action_delete: "Избриши",
    action_cancel: "Откажи",
    confirm_delete_sprite: "Дали сте сигурни дека сакате да го избришете овој спрајт?",
    confirm_delete_project: "Дали сте сигурни дека сакате да го избришете овој проект? Сите sprites ќе бидат отстранети.",
    confirm_delete_sheet: "Дали сте сигурни дека сакате да го избришете овој лист?",
    err_select_sprite: "Прво изберете спрајт.",
    err_select_project: "Прво изберете проект.",
    err_name_empty: "Името не може да биде празно.",
    err_sprite_exists: "Веќе постои спрајт со тоа име.",
    err_project_exists: "Проект со тоа име веќе постои.",
    err_no_content: "Нема содржина за зачувување.",
    err_no_changes: "Нема промени за зачувување.",
    err_delete_last_sheet: "Не може да се избрише последниот лист.",
    err_extract_frames: "Не може да се извлечат никакви рамки.",
    err_indexeddb: "Не успеа да се зачува локално. Вашиот прелистувач можеби нема да поддржува IndexedDB.",
    msg_upload_success: "Поставувањето е успешно: {0}",
    msg_upload_failed: "Поставувањето не успеа: {0}",
    msg_save_success: "Зачувај успешно.",
    msg_saving: "Се зачувува...",
    msg_multi_save_result: "Зачувани {0} средства. {1} неуспеси.",
    menu_title: "Мени",
    menu_save: "Зачувај",
    menu_save_all: "Зачувај ги сите",
    menu_support: "Контактирајте со поддршката",
    label_local_storage: "Локално складирање",
    label_sign_in: "Пријавете се",
    modal_export_title: "Извези Sprite",
    label_filename: "Име на датотека",
    label_format: "Формат",
    action_export_confirm: "Извоз",
};

export default translations;
